import React from 'react'
import { useTranslation } from 'react-i18next'
import { useForm } from 'react-hook-form'
import Loading from '../Loading'

const NewPasswordForm = ({ onSubmit, onBack, isLoading, errorMessage }) => {
    const { t } = useTranslation()

    const {
        register,
        handleSubmit,
        getValues,
        setValue,
        trigger,
        formState: { errors },
    } = useForm({
        defaultValues: {
            password: '',
            repeatPassword: '',
        },
    })

    const handleFormSubmit = (data) => {
        onSubmit(data.password)
    }

    return (
        <div className="new-password-container">
            <div className="modal-title">
                <p className="text-3xl text-white text-left font-bold">{t('newPassword')}</p>
            </div>
            <div className="text-left text-deselectPurple text-sm mt-2" style={{ width: 'unset' }}>
                <p>{t('passwordMustBeLongerThan8CharactersAndMustContainsUppercaseLowercaseNumberAndSpecialSymbol')}</p>
            </div>
            <div className="sign-up-section" style={{ marginTop: '15px' }}>
                <div className="">
                    <form onSubmit={handleSubmit(handleFormSubmit)}>
                        <div className="">
                            <span className="text-white text-lg font-semibold text-left flex justify-start">{t('password')}</span>
                            <input
                                id="new-password-input"
                                className="w-full text-white border border-b-deselectPurple py-3 border-x-0 border-t-0"
                                placeholder={t('password')}
                                style={{ backgroundColor: 'transparent' }}
                                type="password"
                                {...register('password', {
                                    required: true,
                                    pattern: /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[.!@#$%^&*-_]).{8,}/,
                                })}
                                onChange={(e) => {
                                    setValue('password', e.target.value.toString(), { shouldValidate: true })
                                    if (getValues('repeatPassword') !== '') trigger('repeatPassword')
                                }}
                            />
                            <p className="error-message text-[12px] leading-5 min-h-[20px] ">
                                {errors.password?.type === 'required' ? t('youMustFillData') : ''}
                                {errors.password?.type === 'pattern' ? t('passwordMustBeLongerThan8CharactersAndMustContainsUppercaseLowercaseNumberAndSpecialSymbol') : ''}
                            </p>
                        </div>
                        <div className="">
                            <span className="text-white text-lg font-semibold text-left flex justify-start">{t('repeatPassword')}</span>
                            <input
                                id="new-password-repeat-input"
                                className="w-full text-white border border-b-deselectPurple py-3 border-x-0 border-t-0"
                                placeholder={t('repeatPassword')}
                                style={{ backgroundColor: 'transparent' }}
                                type="password"
                                {...register('repeatPassword', {
                                    validate: {
                                        required: (value) => value.length > 0,
                                        correct: (val) => getValues('password') === val,
                                    },
                                })}
                                onChange={(e) => setValue('repeatPassword', e.target.value.toString(), { shouldValidate: true })}
                            />
                            <p className="error-message text-[12px] leading-5 h-5 ">
                                {errors.repeatPassword?.type === 'required' ? t('youMustFillData') : ''}
                                {errors.repeatPassword?.type === 'correct' ? t('passwordsDoNotMatch') : ''}
                            </p>
                        </div>

                        <div className="error-message">{errorMessage}</div>
                        <div className="login-form-element-holder px-6 py-3">
                            <button
                                id="new-password-submit-button"
                                className={`bg-highlightColor text-deepPurple py-3 text-lg font-semibold rounded-full w-full h-[50px] ${
                                    !isLoading ? 'hover:bg-darkPurple hover:text-white' : ''
                                } duration-[250ms] ease-in-out transition-all flex items-center justify-center`}
                                disabled={isLoading}
                            >
                                {isLoading ? <Loading primaryColor="#413F5E" /> : t('submitNewPassword')}
                            </button>
                        </div>
                    </form>
                </div>
                {onBack && (
                    <div>
                        <p className="login-missing-text">
                            <span className="login-missing-text-action" onClick={onBack}>
                                {t('backToLogin')}
                            </span>
                        </p>
                    </div>
                )}
            </div>
        </div>
    )
}

export default NewPasswordForm
